import { createContext, useContext, useState } from "react";

const MFCustomBottlerSelectionContext = createContext();

// Context Provider Component
export const MFCustomBottlerSelectionProvider = ({ children }) => {
  const [customSelectedData, setCustomSelectedData] = useState([]);

  return (
    <MFCustomBottlerSelectionContext.Provider
      value={{ customSelectedData, setCustomSelectedData }}
    >
      {children}
    </MFCustomBottlerSelectionContext.Provider>
  );
};

// Custom Hook for easy access
export const useMFCustomBottlerSelection = () =>
  useContext(MFCustomBottlerSelectionContext);
